const get = function (customerId) {
    return window.axios.get(`/api/customers/${customerId}/postcode-fee`);
};

const save = function (customerId, data) {
    return window.axios.put(`/api/customers/${customerId}/postcode-fee`, data);
};

const destroy = function (customerId) {
    return window.axios.delete(`/api/customers/${customerId}/postcode-fee`);
};

export default {
    get,
    save,
    destroy,
};



// WEBPACK FOOTER //
// ./resources/assets/js/services/CustomerPostcodeFeeService.js